import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  IconButton,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Noimage from "../../../../Image/refusetosign.png";
import nosignImages from "../../../../Image/notsign.png";
import Swal from "sweetalert2";
import nosignImagesSuccess from "../../../../Image/Confirmrefust.png";
import { APIEndpointWeb, GetLocalStorageAccessToken, webapi } from "../../../../client/web";
import { useHistory } from "react-router-dom";

interface RejectSignatureDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: (reason: string) => void;
  resultDetail: any;
  setLoading: (value: boolean) => void;
}

const RejectSignatureDialog: React.FC<RejectSignatureDialogProps> = ({
  open,
  onClose,
  onReject,
  setLoading,
  resultDetail
}) => {
  const [comment, setComment] = useState<string>(""); // ความคิดเห็นที่กรอก
  const [isError, setIsError] = useState<boolean>(false);
  const maxCharacters = 100; // จำนวนอักขระสูงสุด
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false); // ควบคุมการเปิด-ปิด Dialog ยืนยัน
  const [isLoading, setLoadingState] = useState(false);
  const [openConfirmrefusetosign, setOpenConfirmrefusetosign] = useState<boolean>(false); // state สำหรับ Dialog ยืนยันปฏิเสธ
  const [accessToken, setAccessToken] = useState<string>(
    GetLocalStorageAccessToken()
  );
  // const [loading, setLoading] = useState<boolean>(false);
  const [resReject, setResReject] = useState<any>();
    const history = useHistory();


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "ระบบกำลังดำเนินการ",
        html: "กรุณารอสักครู่...",
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // แสดงการโหลด
        },
      });
    } else {
      Swal.close(); // ปิด SweetAlert เมื่อเสร็จ
    }
  }, [isLoading]);
  // console.log('resultDetail :>> ', resultDetail.document_no);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;

    if (inputValue.startsWith(" ")) {
      return;
    }

    if (inputValue.length <= maxCharacters) {
      setComment(inputValue);
      console.log("ความคิดเห็น:", inputValue);

      if (inputValue.trim() !== "") {
        setIsError(false);
      }
    }
  };


  const resetComment = () => {
    setComment("");
    setIsError(false);
  };

  const handleReject = () => {
    if (!comment.trim()) {
      setIsError(true); // ถ้าไม่ได้กรอก ให้แสดง error
      return;
    }
    setConfirmDialogOpen(true); // เปิด Dialog ยืนยันการปฏิเสธ
    onClose();
  };

  const handleCloseConfirmReject = () => {
    setConfirmDialogOpen(false); // ปิด dialog ยืนยันการปฏิเสธ
    resetComment();
  };

  const handleConfirmReject = () => {
    // ปิด Dialog ยืนยันการปฏิเสธ
    console.log("ข้อมูลถูกบันทึก");
    setConfirmDialogOpen(false);
    // setLoadingState(true);
    
    handleRejectDocument()
    // setTimeout(() => {
    //   setLoadingState(false);
    //   setOpenConfirmrefusetosign(true); // เปิด Dialog ยืนยันการปฏิเสธการลงนามสำเร็จ
    // }, 1000);

    // setTimeout(() => {
    //   setOpenConfirmrefusetosign(false);
    //   resetComment();
    // }, 2200); // รีเซ็ตคอมเมนต์หลังจากการยืนยันสำเร็จ
  };


  const handleRejectDocument = async () => {
    try {
      setLoading(true);
      var datax = {
        priority: resultDetail.priority,
        note: comment,
        document_no: resultDetail.document_no
      };
      // console.log("datax", resultDetail)
      // console.log("datax", datax)
      var { data } = await webapi.post(`${APIEndpointWeb.PostRejectDocument}`,datax,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      // if (data.status_result.status_message_code === 201) {
      //   Swal.fire({
      //     title: "ระบบกำลังดำเนินการ",
      //     html: "กรุณารอสักครู่...",
      //     timerProgressBar: true,
      //     allowOutsideClick: false,
      //     didOpen: () => {
      //       Swal.showLoading();
      //     },
      //   });
      // } else {
      //   Swal.close();
      // }
      setOpenConfirmrefusetosign(true)


      setTimeout(() => {
        setOpenConfirmrefusetosign(false); // ปิด Dialog 4 หลังจาก 2 วินาที
        // history.push("/document-personal");
        let params = new URLSearchParams(document.location.search);
        let page = params.get("page");
        window.location.replace(page === "1"? "/document-personal" :page === "2" ? "/pending-document" : page === "3" ? "/admin-page-document" : "/public-health")
      }, 3000); // 4 วินาทีจากจุดเริ่มต้น
      setLoading(false)
      // setResReject(data.result?data.result:'');
    } catch (error: any) {
      // setResReject('');
            console.log("error", error)
            // setLoading(false)
          try {
              Swal.fire({
                title: error.response.data.status_result.status_message_th,
                icon: "error",
                  });
            } catch (error) {
              Swal.fire({
                title: "ปฏิเสธการลงนาม ไม่สำเร็จ",
                icon: "error",
              });
            }
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          resetComment();
          onClose();
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            width: "500px",
          },
        }}
      >
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid
              item
              xs={12}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <img
                  src={Noimage}
                  alt="รูปภาพ"
                  style={{
                    width: 30,
                    height: "auto",
                    marginRight: 8,
                  }}
                />
                <Typography variant="body1" sx={{ fontWeight: "bold", color: "#000", fontSize: "18px" }}>
                  ความคิดเห็นประกอบการปฏิเสธการลงนาม
                </Typography>
              </Box>
              <IconButton onClick={() => { resetComment(); onClose(); }}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12} container justifyContent="space-between">
              <Typography sx={{ color: "#000", fontSize: "16px" }}>
                ความคิดเห็นประกอบการปฏิเสธการลงนาม <span style={{ color: "red" }}>*</span>
              </Typography>
              <Typography
                sx={{
                  mt: 1,
                  color: comment.length === maxCharacters ? "#D32F2F" : "#C4C4C4",
                  fontSize: "12px",
                }}
              >
                {comment.length}/{maxCharacters}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                minRows={4}
                maxRows={6}
                placeholder="กรุณาระบุความคิดเห็น (จำเป็นต้องระบุ)"
                value={comment}
                onChange={handleChange}
                error={isError}
                helperText={isError ? "กรุณากรอกความคิดเห็นก่อนกดบันทึก" : ""}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: isError ? "1px solid #D32F2F" : "1px solid #C4C4C4",
                      borderRadius: "16px",
                    },
                  },
                }}
                inputProps={{
                  maxLength: maxCharacters,
                  style: { fontSize: "16px" },
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            onClick={() => {
              resetComment();
              onClose();
            }}
            sx={{
              width: "120px",
              height: "40px",
              backgroundColor: "#fff",
              color: "#FF4545",
              borderRadius: "20px",
              border: "1px solid #FF4545",
              "&:hover": {
                backgroundColor: "#fcefef",
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleReject}
            sx={{
              width: "120px",
              height: "40px",
              backgroundColor: "#0288D1",
              color: "#fff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "#0277BD",
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog ยืนยันการปฏิเสธการลงนาม */}
      <Dialog
        open={confirmDialogOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return; // ป้องกันการปิดเมื่อกด Esc หรือคลิกพื้นหลัง
          }
          handleCloseConfirmReject(); // ปิด Dialog ตามปกติ
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={handleCloseConfirmReject}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={nosignImages} // ใช้รูปภาพที่เหมาะสม
                alt="รูปภาพ"
                style={{
                  width: 140,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -2,
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ต้องการปฏิเสธการลงนาม
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ท่านต้องการปฏิเสธการลงนามหรือไม่
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                onClick={handleCloseConfirmReject}
                variant="outlined"
                color="error"
                sx={{
                  width: "120px",
                  height: "40px",
                  borderRadius: "20px",
                }}
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleConfirmReject}
                variant="contained"
                sx={{
                  width: "120px",
                  height: "40px",
                  backgroundColor: "#0288D1",
                  borderRadius: "20px",
                  "&:hover": {
                    backgroundColor: "#0277BD",
                  },
                }}
              >
                ยืนยัน
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* Dialog ยืนยันปฏิเสธการลงนามสำเร็จ */}
      <Dialog
        open={openConfirmrefusetosign}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return; // ป้องกันการปิดเมื่อกด Esc หรือคลิกพื้นหลัง
          }
          setOpenConfirmrefusetosign(false); // ปิด Dialog
        }}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            bgcolor: "#FFFFFF",
            borderRadius: "20px",
            boxShadow: 3,
            p: 2,
            width: "400px",
          },
        }}
      >
        <IconButton
          onClick={() => setOpenConfirmrefusetosign(false)}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} display="flex" justifyContent="center">
              <img
                src={nosignImagesSuccess} // ใช้รูปภาพที่เหมาะสม
                alt="รูปภาพ"
                style={{
                  width: 280,
                  height: "auto",
                  marginBottom: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  textAlign: "center",
                  color: "#333333",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ยืนยันการปฏิเสธการลงนามสำเร็จ
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  mt: -1,
                  textAlign: "center",
                  color: "#636363",
                  fontSize: "14px",
                }}
              >
                ทำการยืนยันการปฏิเสธการลงนามเรียบร้อยแล้ว
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RejectSignatureDialog;
